import React from 'react';
import { useMsal } from '@azure/msal-react';

interface WaitingRoomProps {
    onBypass: () => void;
}

const WaitingRoom: React.FC<WaitingRoomProps> = ({ onBypass }) => {
    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect().catch(e => console.error(e));
    };

    return (
        <div 
            className="min-h-screen w-full bg-slate-50 dark:bg-[#0d131b] flex flex-col items-center justify-center p-6 font-display"
            style={{
                paddingTop: "calc(1.5rem + env(safe-area-inset-top, 0px))",
                paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom, 0px))"
            }}
        >
            <div className="max-w-md w-full bg-white dark:bg-[#1a2634] rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 p-10 text-center animate-scale-up">
                <div className="w-20 h-20 rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-500 mx-auto flex items-center justify-center mb-6 shadow-inner">
                    <span className="material-symbols-outlined text-4xl">hourglass_empty</span>
                </div>
                <h1 className="text-2xl font-black text-slate-800 dark:text-white mb-3">En Sala de Espera</h1>
                <p className="text-slate-500 dark:text-slate-400 text-sm mb-8 leading-relaxed">
                    Hemos verificado tu identidad corporativa exitosamente. Sin embargo, aún no tienes **Obras asignadas** a tu perfil.
                    <br/><br/>
                    Por favor, contacta a un <strong className="text-slate-700 dark:text-slate-200">Administrador de la Plataforma</strong> para que te asigne a un proyecto y defina tu rol.
                </p>
                
                <div className="space-y-3">
                    <button 
                        onClick={onBypass}
                        className="w-full py-4 bg-primary text-white rounded-xl font-bold hover:bg-blue-600 transition-all flex items-center justify-center gap-2 shadow-lg shadow-primary/20"
                    >
                        Continuar a la plataforma
                        <span className="material-symbols-outlined text-[20px]">arrow_forward</span>
                    </button>
                    <button 
                        onClick={handleLogout}
                        className="w-full py-4 rounded-xl border-2 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-primary transition-all flex items-center justify-center gap-2"
                    >
                        <span className="material-symbols-outlined">logout</span>
                        Cerrar Sesión
                    </button>
                </div>
            </div>
            
            <div className="mt-8 text-center text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center justify-center gap-2">
                <span className="material-symbols-outlined text-[14px]">shield</span>
                K-LyDapp Security
            </div>
        </div>
    );
};

export default WaitingRoom;
